<template>
  <router-link v-if="type === 'internal'" :to="to">{{ text }}</router-link>
  <a v-else :href="to" target="_blank">{{ text }}</a>
</template>

<script>
export default {
  name: "LinkButton",
  props: {
    to: String,
    text: String,
    type: String
  }
};
</script>

<style lang="scss" scoped>
a {
  color: white;
  background-color: $secondary-light-green;
  text-decoration: none;
  font-size: 1.25em;
  padding: 0.5rem 2rem;
  font-family: "DunbarLow-Medium";
  text-transform: uppercase;
}
</style>
